import { render } from "./ResourceContent.vue?vue&type=template&id=80be23e2"
import script from "./ResourceContent.vue?vue&type=script&lang=js"
export * from "./ResourceContent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\server\\www\\kpowa-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__